<label class="form-label" *ngIf="!isEmbed">CAPTCHA</label>

<div *ngIf="captchaType === 'hCaptcha'">
  <div id="hCaptchaContainer"></div>
</div>

<button id="captchaRenderBtn" (click)="renderhCaptcha()"></button>
